import React, { useEffect } from "react";
import "./VipBenefits.css";
import { useDispatch, useSelector } from "react-redux";
import { AllTurnTableRule, AllVipBenfitById } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { formatAmount, formatOnlyAmount } from "../../../utils/common";

// Data extracted from your video recording
const BENEFIT_DATA = {
  "1": { levelUp: "1,290", monthly: "690", safe: "0.25%", rebate: "0.65%" },
  "2": { levelUp: "2,000", monthly: "800", safe: "0.26%", rebate: "0.66%" },
  "3": { levelUp: "3,500", monthly: "1,000", safe: "0.27%", rebate: "0.67%" },
  "4": { levelUp: "1,290", monthly: "690", safe: "0.25%", rebate: "0.65%" },
  "5": { levelUp: "6,900", monthly: "1,690", safe: "0.3%", rebate: "0.7%" },
  "6": { levelUp: "16,900", monthly: "4,900", safe: "0.325%", rebate: "0.75%" },
  "7": { levelUp: "69,000", monthly: "16,900", safe: "0.325%", rebate: "0.7%" },
  "8": { levelUp: "169,000", monthly: "69,000", safe: "0.35%", rebate: "0.75%" },
  "9": { levelUp: "690,000", monthly: "169,000", safe: "0.35%", rebate: "0.8%" },
};

function VipBenefits({ activeLevel = 1 }) {
  // Select data based on activeLevel, fallback to level 1 if not found
  const currentBenefits = BENEFIT_DATA[activeLevel] || BENEFIT_DATA["1"];


  const dispatch = useDispatch()

  const levelBenefits = useSelector((state) => state.common.all_benefit_by_id);


  useEffect(() => {
    dispatch(AllVipBenfitById(activeLevel + 1));
  }, [activeLevel, dispatch]);

  return (
    <div className="vip_benefits">
      <h3>VIP{activeLevel} Benefits level</h3>

      {/* Level up rewards */}
      {levelBenefits?.map((data) => (

        <div className="benefit_item">
          <div className="benefit_item_holder">
            <div className="img_holder">
              <img src={IDS.IMG_URL + data?.Benefit?.image} alt="gift" className="benefit_icon" />
              {/* <img src="/assets/images/vip/vip_icons/gift.webp" alt="gift" className="benefit_icon" /> */}
            </div>
            <div className="benefit_item_text_holder">
              <h4>{data?.Benefit?.name || ""}</h4>
              <p>{data?.Benefit?.remark || ""}</p>
            </div>
          </div>

          {data?.type === "percent" ?
            <div className="points_holder">
              <div className="benefit_value red_box">🎯 {data?.value || ""}</div>
            </div>
            :
            <div className="points_holder">
              <div className="benefit_value orange_box">🪙 {formatOnlyAmount(data?.value) || ""}</div>
              <div className="benefit_value red_box">❤️ 0</div>
            </div>

          }

        </div>
      ))}

    </div>
  );
}

export default VipBenefits;